// extracted by mini-css-extract-plugin
export default {"ourClients":"styles_ourClients__mlsbG","clients":"styles_clients__cnEfO"};